export default __webpack_public_path__ + "static/media/shield.cc212996.svg";